






























import {
  Vue, Component, Prop, Watch, Mixins,
} from 'vue-property-decorator'
import { includes, clone } from 'ramda'
import {
  getModule,
} from 'vuex-module-decorators'
import firebase from 'firebase/app'
import router from 'vue-router'
import {
  update, field, collection, get, query, where, set, add, value, getMany,
} from 'typesaurus'
import MainMixin from './mixins/MainMixin'
import NavBar from './components/layout/NavBar.vue'
import AppStore from './store/modules/app'
import Chat from './components/chat/Chat.vue'
import UserStore from './store/modules/user'
import LocationStore from './store/modules/location'
import Settings from './views/Settings.vue'
import AllNotifications from './components/notifications/AllNotifications.vue'
import {
  LocationListType, LocationType, UserType, LocationCollection, NotificationType,
} from './types'

@Component({
  components: {
    NavBar,
    Settings,
    Chat,
    AllNotifications,
  },
})

export default class App extends Mixins(MainMixin) {
  name = 'NavBar'

  drawer = true

  sidebar = true

  mUser = false

  showNotifications = false

  online = true

  AppStore = getModule(AppStore)

  UserStore = getModule(UserStore)

  LocationStore = getModule(LocationStore)

  get userExists() {
    if (this.UserStore.uid) return true
    return false
  }

  get userProfileComplete() {
    if (this.$store.state.user.auth && this.$store.state.user.auth.phone) return true
    return false
  }

  get currentRoute() {
    console.log('route : ', router)
    return 'ok'
  }

  get userSet() {
    if (!this.UserStore || !this.UserStore.userBound) return false
    return true
  }

  logout() {
    firebase.auth().signOut()
  }

  get location() {
    return this.$store.getters.location
  }

  @Watch('showNotifications')
  showNotificationChange(newValue:boolean) {
    if (newValue === false) {
      this.$store.dispatch('setViewTime')
    }
  }
  // @Watch('location')
  // locationSet(newLocation:string) {
  //   console.log('location now set to: ', newLocation)
  //   console.log('binding notifications')
  //   setTimeout(() => {
  //     const gp = clone(this.$store.getters.group)
  //     console.log('here group is: ', gp)
  //     this.$store.dispatch('bindNotifications', { location: newLocation, gp })
  //   }, 1000)
  // }

  // @Watch('userSet', { immediate: true })
  // async onUserChange(newStatus:boolean, oldStatus:boolean) {
  //   if (newStatus) {
  //     let locations:LocationListType[] = []
  //     if (this.$store.state.user.auth.locations && this.$store.state.user.auth.locations === 1) {
  //       await this.LocationStore.bindLocation(this.$store.state.users.auth.locations[0])
  //       this.$toast.success('Successfully Logged In To Location')
  //     } else {
  //       // eslint-disable-next-line prefer-destructuring
  //       const allLocations = await getMany(LocationCollection, this.$store.state.user.auth.locations)
  //       locations = allLocations.map(loc => ({ name: loc.data.name, avatar: loc.data.avatar, id: loc.ref.id }))
  //       this.UserStore.setLocationList(locations)
  //       const lastLocation = window.localStorage.getItem('lastLocation')
  //       const queryLocation = window.localStorage.getItem('queryLocation')
  //       if (queryLocation && includes(queryLocation, locations.map(location => location.id))) {
  //         await this.LocationStore.bindLocation(queryLocation)
  //         const locationName = locations.find(location => location.id === queryLocation)
  //         Vue.prototype.$toast.success(`Successfully Logged Into ${locationName !== undefined ? locationName.name : 'Location'}`)
  //         window.localStorage.removeItem('queryLocation')
  //       } else if (lastLocation && includes(lastLocation, locations.map(location => location.id))) {
  //         await this.LocationStore.bindLocation(lastLocation)
  //         const locationName = locations.find(location => location.id === lastLocation)
  //         this.$toast.success(`Successfully Logged Into ${locationName !== undefined ? locationName.name : 'Location'}`)
  //       }
  //     }
  //   }
  // }

  userLinks = [
    { title: 'Messages', icon: 'mdi-message', link: 'messages' },
    { title: 'Coupons', icon: 'mdi-ticket-percent', link: 'coupons' },
    { title: 'Tasks', icon: 'mdi-file-tree', link: 'tasks' },
    { title: 'Info Board', icon: 'mdi-information', link: 'information' },
    { title: 'Requests Off', icon: 'mdi-calendar', link: 'request-off' },
    { title: 'Schedule', icon: 'mdi-calendar-multiple-check', link: 'schedule' },
  ]

  formLinks = [
    { title: 'Comment Cards', link: 'comment-card' },
    { title: 'Incident Report', link: 'incident-report' },
    { title: 'Joker Draw', link: 'joker-draw' },
    { title: 'Manager Report', link: 'manager-report' },
    { title: 'New Message', link: 'new-message' },
    { title: 'Server Report', link: 'server-report' },
    { title: 'Written Check', link: 'written-check' },
  ]

  managerLinks = [
    { title: 'Customers', link: 'customers' },
    { title: 'Display Boards', link: 'display-boards' },
    { title: 'Email', link: 'email' },
    { title: 'Manage Coupons', link: 'manage-coupons' },
    { title: 'Manange Info Boards', link: 'manage-info-boards' },
    { title: 'Manange Requests Off', link: 'manage-requests-off' },
    { title: 'Reports', link: 'reports' },
    { title: 'Setup Tasks', link: 'setup-tasks' },
    { title: 'SMS', link: 'sms' },
    { title: 'Submissions', link: 'submissions' },
    { title: 'Users', link: 'users' },
  ]
}
